enum PlatformClientUserFilterType {
    CLIENT_PLANS = 'CLIENT_PLANS',
    CLIENT_VERIFIED = 'CLIENT_VERIFIED',
    CLIENT_ARCHIVED = 'CLIENT_ARCHIVED',
    CLIENT_TEAMS = 'CLIENT_TEAMS',
}

export default PlatformClientUserFilterType;
